import debug from 'debug';
import { selectors } from 'app-webtech-core';
import { PAGE_ID } from '../../constants';

const log = debug('playbackSession:helpers:getChannelByTimelineId');

// Assuming a timeline belongs to exactly 1 channel
// returns channel's ID (string) or null
const getChannelByTimelineId = (timelineId, state) => {
  const { entities } = selectors.linearChannels.properties(state);

  if (entities && entities.linearChannels) {
    const channel = Object.values(entities.linearChannels)
      .filter((linearChannel) => linearChannel.timelines)
      .find((linearChannel) => linearChannel.timelines.includes(timelineId));

    if (channel) {
      log('timelineId: %o channel._id: %o', timelineId, channel._id);
      return channel._id;
    }
  }

  return PAGE_ID[state.page];
};

export { getChannelByTimelineId };
